export default "__VITE_ASSET__DuiJ7FRa__"